import React, { useState } from 'react';
import { DrillDownDimensionType, FieldType, MsgDataType } from '../common/type';
import { isMobile } from '../utils';
import MetricTrendChart from './MetricTrendChart';
import CTable from '../../CTable';
import MetricInfo from './MetricInfo';
import DateOptions from '../DateOptions';
import MultiMetricsTrendChart from './MultiMetricsTrendChart';
import CustomSpinner from '../components/CustomSpinner';
import CustomSelect from '../components/CustomSelect';
import styles from './index.module.scss';

const metricChartSelectOptions = [
  {
    value: 'line',
    label: '折线图',
  },
  {
    value: 'bar',
    label: '柱状图',
  },
];

type Props = {
  data: MsgDataType;
  question: string;
  chartIndex: number;
  triggerResize?: boolean;
  loading: boolean;
  activeMetricField?: FieldType;
  drillDownDimension?: DrillDownDimensionType;
  currentDateOption?: number;
  onApplyAuth?: (model: string) => void;
  onSelectDateOption: (value: number) => void;
}; 
const MetricTrend: React.FC<Props> = ({
  data,
  question,
  chartIndex,
  triggerResize,
  loading,
  drillDownDimension,
  currentDateOption,
  onApplyAuth,
  onSelectDateOption,
}) => {
  const { queryColumns, queryResults, aggregateInfo, entityInfo, chatContext } = data;
  const [chartType, setChartType] = useState('line');

  const columns = queryColumns.map((item) => {
    return {
      ...item,
      name: item.name,
      code: item.bizName || item.nameEn,
    }
  })

  const dateField: any = queryColumns?.find(
    (column: any) => column.showType === 'DATE' || column.type === 'DATE'
  );
  const dateColumnName = dateField?.nameEn || '';
  const categoryColumnName =
    queryColumns?.find((column: any) => column.showType === 'CATEGORY')?.nameEn || '';
  const metricFields = queryColumns?.filter((column: any) => column.showType === 'NUMBER');

  const currentMetricField = queryColumns?.find((column: any) => column.showType === 'NUMBER');

  if (!currentMetricField) {
    return null;
  }

  return (
    <div className={styles.metricTrend}>
      <div className={styles.charts}>
        {/* 暂时隐藏问题 */}
        {/* <div className={styles.topBar}>
          <div className={`${styles.metricFields} ${styles.metricFieldSingle}`}>
            {question}
          </div>
        </div> */}
        <CustomSpinner spinning={loading}>
          <div className={styles.content}>
            {!isMobile &&
              aggregateInfo?.metricInfos?.length > 0 &&
              drillDownDimension === undefined && (
                <MetricInfo aggregateInfo={aggregateInfo} currentMetricField={currentMetricField} />
              )}
            <div className={styles.selectOptions}>
              {currentDateOption && <DateOptions
                chatContext={chatContext}
                currentDateOption={currentDateOption}
                onSelectDateOption={onSelectDateOption}
              />}
              <div>
                <CustomSelect
                  defaultValue="line"
                  bordered={false}
                  options={metricChartSelectOptions}
                  onChange={(value: string) => setChartType(value)}
                />
              </div>
            </div>
            {queryResults?.length === 1 || chartIndex % 2 === 1 ? (
              <CTable
                content={{
                  header: columns,
                  rows: queryResults || [],
                }}
                // paging={true}
                // scroll={{ x: 'max-content' }}
              />
            ) : metricFields.length > 1 ? (
              // 添加数据验证，确保数据准备好后再渲染图表
              queryResults && queryResults.length > 0 && metricFields.length > 0 ? (
                <MultiMetricsTrendChart
                  dateColumnName={dateColumnName}
                  metricFields={metricFields}
                  resultList={queryResults}
                  triggerResize={triggerResize}
                  chartType={chartType}
                />
              ) : (
                <div style={{ padding: '20px', textAlign: 'center', color: '#999' }}>
                  暂无数据
                </div>
              )
            ) : (
              // 添加数据验证，确保数据准备好后再渲染图表
              queryResults && queryResults.length > 0 && currentMetricField ? (
                <MetricTrendChart
                  model={entityInfo?.dataSetInfo.name}
                  dateColumnName={dateColumnName}
                  categoryColumnName={categoryColumnName}
                  metricField={currentMetricField}
                  resultList={queryResults}
                  triggerResize={triggerResize}
                  onApplyAuth={onApplyAuth}
                  chartType={chartType}
                />
              ) : (
                <div style={{ padding: '20px', textAlign: 'center', color: '#999' }}>
                  暂无数据
                </div>
              )
            )}
          </div>
        </CustomSpinner>
      </div>
    </div>
  );
};

export default MetricTrend;
